module.exports = __webpack_public_path__ + "img/17.9cec5882.jpg";